/*********************** Custom JS for Boost AI Search & Discovery  ************************/

// Make sure the header search and instant are the same width
function matchSearchWidth() {
  const input = document.querySelector(
    '.header-top .header__icons .search-modal__form input, .header-bottom .search-modal__form input'
  );
  const wrapper = document.getElementById('boost-sd__search-widget-init-wrapper');

  if (!input || !wrapper) return;

  wrapper.style.width = input.offsetWidth + 'px';
}

(function () {

  /*********************** Vendor Links ************************/

  function getCollectionHandleFromVendor(vendorName) {
    if (!vendorName || typeof vendorName !== 'string') return null;
    var brand = vendorName.trim();
    if (!brand) return null;

    if (typeof window !== 'undefined' && window.brandToCollectionHandle) {
      if (window.brandToCollectionHandle[brand]) {
        return window.brandToCollectionHandle[brand];
      }
      var escaped = brand.replace(/&/g, '&amp;');
      if (window.brandToCollectionHandle[escaped]) {
        return window.brandToCollectionHandle[escaped];
      }
    }

    return brand.toLowerCase().replace(/ /g, '-').replace(/&/g, '').replace(/[^a-z0-9-]/g, '');
  }

  function wrapBoostVendorsInCollectionLinks() {
    document.querySelectorAll('.boost-sd__product-vendor, .boost-sd__quick-view-vendor').forEach(function (el) {
      if (el.querySelector('a')) return;

      var hiddenSpan = el.querySelector('.boost-sd__visually-hidden');
      if (hiddenSpan) hiddenSpan.remove();

      var vendorText = el.textContent.trim();
      if (!vendorText) return;

      var handle = getCollectionHandleFromVendor(vendorText);
      var anchor = document.createElement('a');
      anchor.href = '/collections/' + handle;
      anchor.textContent = vendorText;

      el.innerHTML = '';
      el.appendChild(anchor);
    });
  }

  /*********************** Price Formatting ************************/

  function formatBoostPrices() {
    document.querySelectorAll('.boost-sd__format-currency').forEach(function (el) {
      if (el.querySelector('span')) return;
      if (el.dataset.priceFormatted) return;

      var text = el.textContent.trim();
      var match = text.match(/^([^0-9]*)([0-9]+(?:\.[0-9]*)?)(.*)$/);
      if (!match) return;

      var prefix = match[1];
      var number = match[2];
      var suffix = match[3];

      el.textContent = prefix + parseFloat(number).toFixed(2) + suffix;
      el.dataset.priceFormatted = '1';
    });
  }

  /*********************** ISW Image Quality ************************/

function upgradeIswImageQuality() {
  document.querySelectorAll('.boost-sd__suggestion-queries-item-img').forEach(function (img) {
    if (img.dataset.imgUpgraded) return;

    // Fix src: replace width=100 with width=300
    var src = img.getAttribute('src');
    if (src) {
      img.setAttribute('src', src.replace(/width=\d+/, 'width=400'));
    }

    // Fix srcset: replace width=100 and width=200 with width=300
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var newSrcset = srcset
        .split(',')
        .map(function (entry) {
          entry = entry.trim();
          // Only upgrade the 100w and 200w entries, leave 300w+ as-is
          if (entry.includes('width=100 ') || entry.includes('width=200 ') || entry.includes('width=300 ')) {
            return entry.replace(/width=\d+/, 'width=400');
          }
          return entry;
        })
        .join(', ');
      img.setAttribute('srcset', newSrcset);
    }

    img.dataset.imgUpgraded = '1';
  });
}

  /*********************** Search Click Attribution ************************/
  // Shopify's native "Searches with no clicks" / "Search conversions over time" reports key
  // off _pos, _sid and _ss=r query params on product links. Boost's AI Search & Discovery
  // grid (widget v1.72.7) renders its own product links and omits all three, so 100% of
  // Boost-rendered searches show as unclicked in Shopify's native analytics even though
  // Boost's own Search Analytics dashboard is tracking clicks independently.
  //
  // Shopify still server-renders its native results into the DOM with the real params --
  // Boost just visually hides them (display:none) under its own grid. Rather than invent
  // our own session id, we read the one Shopify already generated off a hidden native link
  // and stamp it (+ each item's Boost-rendered position, + _ss=r) onto the visible Boost
  // links. This makes Boost-rendered clicks attributable in Shopify's native reports without
  // touching Boost's own vendor-controlled template.

  function isSearchResultsPage() {
    return /^\/search\/?$/.test(window.location.pathname);
  }

  function getNativeSearchSessionId() {
    var nativeLink = document.querySelector('a.full-unstyled-link[href*="_sid="]');
    if (!nativeLink) return null;

    try {
      var url = new URL(nativeLink.getAttribute('href'), window.location.origin);
      return url.searchParams.get('_sid');
    } catch (e) {
      return null;
    }
  }

  function tagBoostSearchLinksWithAttribution() {
    if (!isSearchResultsPage()) return;

    // Native block may not have rendered yet on the first pass -- next mutation will retry.
    var sid = getNativeSearchSessionId();
    if (!sid) return;

    var untaggedLinks = document.querySelectorAll('.boost-sd__product-link:not([data-attr-tagged])');
    if (untaggedLinks.length === 0) return;

    // Position reflects the order Boost actually shows the shopper, not Shopify's native
    // order. Each product can have more than one link (image + title) sharing one position,
    // so we key by product id and only increment pos for products we haven't seen yet.
    var allLinks = document.querySelectorAll('.boost-sd__product-link');
    var posByProductKey = new Map();
    var pos = 0;

    allLinks.forEach(function (link) {
      var item = link.closest('.boost-sd__product-item');
      var key = item ? (item.dataset.productId || item.getAttribute('data-product-id')) : link.getAttribute('href');
      if (!key) return;
      if (!posByProductKey.has(key)) {
        pos += 1;
        posByProductKey.set(key, pos);
      }
    });

    untaggedLinks.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;

      var item = link.closest('.boost-sd__product-item');
      var key = item ? (item.dataset.productId || item.getAttribute('data-product-id')) : href;
      var itemPos = posByProductKey.get(key) || 1;

      try {
        var url = new URL(href, window.location.origin);
        url.searchParams.set('_pos', String(itemPos));
        url.searchParams.set('_sid', sid);
        url.searchParams.set('_ss', 'r');
        link.setAttribute('href', url.pathname + url.search);
        link.dataset.attrTagged = '1';
      } catch (e) {
        // Leave the link untouched if it's not a parseable URL.
      }
    });
  }

 /*********************** Previously Purchased Labels ************************/

  var purchasedIdSet = null;
  var fetchPromise   = null;

  function applyPurchasedLabels() {
    if (purchasedIdSet === null) return;

    // Boost cards
    document.querySelectorAll('.boost-sd__product-item').forEach(function (item) {
      if (item.querySelector('.bc-purchased-label')) return;
      var productId = String(item.dataset.productId || item.getAttribute('data-product-id') || '');
      if (!productId || !purchasedIdSet.has(productId)) return;
      var imageWrapper = item.querySelector('.boost-sd__product-image-wrapper');
      var labelTarget = (imageWrapper && imageWrapper.parentElement) || item;
      labelTarget.style.position = 'relative';
      var label = document.createElement('div');
      label.className = 'bc-purchased-label';
      label.textContent = 'PURCHASED';
      label.style.cssText = 'position:absolute;bottom:8px;left:8px;background:#C5A03A;color:#fff;font-size:12px;font-weight:600;padding:2px 6px;border-radius:4px;z-index:1;pointer-events:none;';
      labelTarget.appendChild(label);
    });

    // Regular theme cards (paginated pages)
    document.querySelectorAll('.card-wrapper[data-product-id]').forEach(function (item) {
      if (item.querySelector('.bc-purchased-label')) return;
      var productId = String(item.dataset.productId || '');
      if (!productId || !purchasedIdSet.has(productId)) return;
      var imageContainer = item.querySelector('.card__inner');
      var labelTarget = imageContainer || item;
      labelTarget.style.position = 'relative';
      var label = document.createElement('div');
      label.className = 'bc-purchased-label';
      label.textContent = 'PURCHASED';
      label.style.cssText = 'position:absolute;bottom:8px;left:8px;background:#C5A03A;color:#fff;font-size:12px;font-weight:600;padding:2px 6px;border-radius:4px;z-index:3;pointer-events:none;';
      labelTarget.appendChild(label);
    });
  }

  function fetchAndApplyPurchasedLabels(customerId) {
    if (fetchPromise) return;
    fetchPromise = fetch(
      'https://whm-my-media-backend.vercel.app/api/purchased-products?customerId=' +
        encodeURIComponent(customerId)
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        purchasedIdSet = new Set((data.productIds || []).map(String));
        fetchPromise = null;
        applyPurchasedLabels();
      })
      .catch(function (err) {
        console.warn('[purchased] fetch failed:', err);
        purchasedIdSet = new Set();
        fetchPromise = null;
      });
  }

   /*********************** Hover Auto Play Preview ************************/
  function attachVideoHovers() {
    document.querySelectorAll('.boost-sd__product-item:not([data-video-hover])').forEach(item => {
      const video = item.querySelector('.boost-sd__hover-preview-video');
      const wrapper = item.querySelector('.boost-sd__product-image-wrapper');
      const pill = item.querySelector('.video-length-pill');
      if (!video || !wrapper) return;

      item.dataset.videoHover = '1';
      video.preload = 'metadata';

      let playPending = false;
      let leaveTimer = null;

      const duration = pill ? parseFloat(pill.dataset.duration) : 0;
      const originalText = pill ? pill.textContent : '';

      function formatTime(totalSeconds) {
        const s = Math.max(0, Math.floor(totalSeconds));
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return m + ':' + String(sec).padStart(2, '0');
      }

      function updateCountdown() {
        if (!pill || !duration) return;
        const remaining = duration - video.currentTime;
        pill.textContent = formatTime(remaining);
      }

      function startVideo() {
        if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
        if (video.readyState < 2) {
          if (playPending) return;
          playPending = true;
          video.load();
          video.addEventListener('canplay', () => {
            playPending = false;
            video.play().catch(() => {});
            video.classList.add('is-playing');
          }, { once: true });
        } else {
          video.play().catch(() => {});
          video.classList.add('is-playing');
        }
      }

      function stopVideo() {
        leaveTimer = setTimeout(() => {
          playPending = false;
          video.pause();
          video.currentTime = 0;
          video.classList.remove('is-playing');
          if (pill) pill.textContent = originalText;
          leaveTimer = null;
        }, 100);
      }

      video.addEventListener('timeupdate', updateCountdown);

      wrapper.addEventListener('mouseenter', startVideo);

      wrapper.addEventListener('mouseleave', (e) => {
        const rect = wrapper.getBoundingClientRect();
        const inside = (
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom
        );
        if (inside) return;
        stopVideo();
      });
    });
  }

  /*********************** Init ************************/

  function init() {
    wrapBoostVendorsInCollectionLinks();
    formatBoostPrices();
    upgradeIswImageQuality();
    matchSearchWidth();
    attachVideoHovers();
    tagBoostSearchLinksWithAttribution();

    var customerId = window.__shero && window.__shero.customerId;
    if (customerId) {
      if (purchasedIdSet !== null) {
        applyPurchasedLabels();
      } else {
        fetchAndApplyPurchasedLabels(customerId);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', matchSearchWidth);

  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (shouldRun) init();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  /*********************** Quick View ATC ************************/

  var cartVariantSet = null;

  function fetchCartState() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartVariantSet = new Set((cart.items || []).map(function (i) { return String(i.variant_id); }));
      })
      .catch(function () { cartVariantSet = new Set(); });
  }

  // Fetch cart once on load so we can reflect current state when modal opens
  fetchCartState();

  function getQvAddedHTML() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">' +
      '<path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg><span>Added to cart</span>';
  }

  function setQvButtonAdded(btn) {
    btn.dataset.added = '1';
    btn.disabled = false;
    btn.classList.add('qv-atc--added', 'qv-atc--go-to-cart');
    btn.innerHTML = getQvAddedHTML();
    btn.onclick = function () {
      btn.disabled = true;
      btn.innerHTML = '<span>Redirecting...</span>';
      setTimeout(function () { window.location.href = '/cart'; }, 400);
    };
  }

  function applyQvCartState(modal) {
    var btn = modal.querySelector('.boost-sd__btn-add-to-cart');
    if (!btn || btn.dataset.added || !cartVariantSet) return;
    var variantId = btn.dataset.variantId;
    if (variantId && cartVariantSet.has(String(variantId))) {
      setQvButtonAdded(btn);
    }
  }

  function applyQvOwnershipState(modal) {
    var productId = String(modal.dataset.productId || '');
    if (!productId || !purchasedIdSet || !purchasedIdSet.has(productId)) return;

    var btnWrapper = modal.querySelector('.boost-sd__quick-view-btn');
    if (!btnWrapper || btnWrapper.dataset.ownershipApplied) return;
    btnWrapper.dataset.ownershipApplied = '1';

    btnWrapper.innerHTML =
      '<a href="/account#my-media" class="boost-sd__button boost-sd__button--border boost-sd__button--large qv-go-to-my-media">Go to My Media</a>';
  }

  function checkQvState() {
    var modal = document.getElementById('boost-sd__modal-quickview');
    if (!modal) return;

    // Boost renders the modal across multiple DOM mutations; the button may not have
    // data-variant-id yet on the first fire. Defer to let Boost finish rendering.
    setTimeout(function () {
      var m = document.getElementById('boost-sd__modal-quickview');
      if (!m) return;

      // Ownership check (logged-in customers who already bought the product)
      if (purchasedIdSet !== null) {
        applyQvOwnershipState(m);
      } else if (fetchPromise) {
        fetchPromise.then(function () {
          var m2 = document.getElementById('boost-sd__modal-quickview');
          if (m2) applyQvOwnershipState(m2);
        });
      }

      // Cart state check -- if fetch hasn't resolved yet, wait for it
      if (cartVariantSet !== null) {
        applyQvCartState(m);
      } else {
        fetchCartState().then(function () {
          var m2 = document.getElementById('boost-sd__modal-quickview');
          if (m2) applyQvCartState(m2);
        });
      }
    }, 100);
  }

  function resetQvButton(btn) {
    delete btn.dataset.added;
    btn.disabled = false;
    btn.classList.remove('qv-atc--added', 'qv-atc--go-to-cart');
    btn.onclick = null;
    btn.innerHTML = '<span class="boost-sd__button-text">Add to Cart</span>';
  }

  function syncQvButtonWithCart() {
    fetchCartState().then(function () {
      var modal = document.getElementById('boost-sd__modal-quickview');
      if (!modal) return;
      var btn = modal.querySelector('.boost-sd__btn-add-to-cart');
      if (!btn || !btn.dataset.added) return;
      var variantId = btn.dataset.variantId;
      if (variantId && cartVariantSet && !cartVariantSet.has(String(variantId))) {
        resetQvButton(btn);
      }
    });
  }

  // Re-sync the QV button whenever the Dawn cart updates (item removed, quantity changed, etc.)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      syncQvButtonWithCart();
    });
  }

  // Hook into init so checks run whenever the modal appears in the DOM
  var _origInit = init;
  init = function () {
    _origInit();
    checkQvState();
  };

  // Close quick view when clicking the backdrop (Boost only wires the X button by default)
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('boost-sd__modal-backdrop')) return;
    var closeBtn = document.querySelector('#boost-sd__modal-quickview .boost-sd__modal-close-btn');
    if (closeBtn) closeBtn.click();
  }, true);

  // ATC click handler -- useCapture:true fires before Boost's bubbling listeners
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.boost-sd__btn-add-to-cart');
    if (!btn || !btn.closest('#boost-sd__modal-quickview')) return;

    // "go-to-cart" state: redirect to /cart
    if (btn.classList.contains('qv-atc--go-to-cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (typeof btn.onclick === 'function') btn.onclick();
      return;
    }

    // Button already in loading/added state — swallow the click
    if (btn.disabled || btn.dataset.adding) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var variantId = btn.dataset.variantId;
    // No variantId yet — Boost hasn't finished rendering; let it handle the click
    if (!variantId) return;

    // Read product data from the modal JSON blob (already in DOM -- no template push needed)
    var modal = document.getElementById('boost-sd__modal-quickview');
    var productData = {};
    try { productData = JSON.parse((modal && modal.dataset.product) || '{}'); } catch (_) {}

    var handle   = btn.dataset.productHandle || productData.handle || '';
    var variants = productData.variants || [];
    // Single-variant products add directly; multi-variant need a license/option choice on PDP.
    // Check variants.length rather than title so custom variant names don't cause a silent fallback.
    var isDefault = btn.dataset.isDefaultOption === 'true' || variants.length === 1;

    // Multi-variant product: send to PDP so customer picks an option
    if (!isDefault) {
      if (handle) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = '/products/' + handle;
      }
      // No handle available — let Boost's own handler run
      return;
    }

    // Single-variant ATC — take full control
    e.preventDefault();
    e.stopImmediatePropagation();

    btn.disabled = true;
    btn.dataset.adding = '1';

    var span = btn.querySelector('.boost-sd__button-text');
    if (span) span.textContent = 'Adding...';

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (parsedState) {
      delete btn.dataset.adding;

      if (parsedState.status === 422 || parsedState.error) {
        btn.disabled = false;
        if (span) span.textContent = parsedState.description || 'Unavailable';
        setTimeout(function () { if (span) span.textContent = 'Add to Cart'; }, 2500);
        return;
      }

      // Track in local cart set so re-opening the modal reflects the added state
      if (cartVariantSet) cartVariantSet.add(String(variantId));

      // Switch button to "added" state -- clicking again goes to /cart
      setQvButtonAdded(btn);

      // Fade the quick view out, then open the cart drawer after modal is fully closed
      // (opening drawer while modal is still mounted causes Dawn's trapFocus to throw on null)
      var qvModal = document.getElementById('boost-sd__modal-quickview');
      var qvContainer = qvModal && qvModal.querySelector('.boost-sd__modal-container');
      if (qvContainer) {
        qvContainer.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        qvContainer.style.opacity = '0';
        qvContainer.style.transform = 'scale(0.96)';
        setTimeout(function () {
          var closeBtn = qvModal.querySelector('.boost-sd__modal-close-btn');
          if (closeBtn) closeBtn.click();
          // Separate task: let Boost's synchronous close handler finish before
          // renderContents triggers open() and trapFocus -- prevents intermittent collision.
          setTimeout(function () {
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(parsedState);
            }
          }, 50);
        }, 320);
      } else {
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(parsedState);
        }
      }
    })
    .catch(function (err) {
      delete btn.dataset.adding;
      btn.disabled = false;
      if (span) span.textContent = 'Error - try again';
      console.error('[QV ATC]', err);
      setTimeout(function () { if (span) span.textContent = 'Add to Cart'; }, 2500);
    });
  }, true); // capture phase -- fires before Boost's bubbling listener

})();

// Mini Movies list layout - only on this collection
(function () {

  function onMiniMovies() {
    return /^\/collections\/mini-movies\/?$/.test(window.location.pathname);
  }

  function toggleDescriptions() {
    const show = onMiniMovies();

    document.querySelectorAll('.boost-sd__product-description').forEach(el => {
      el.style.display = show ? '' : 'none';
    });
  }

  function ensureStyle() {
    toggleDescriptions();
    if (!onMiniMovies()) return;
    if (document.getElementById('mini-movies-list-style')) return;

    var s = document.createElement('style');
    s.id = 'mini-movies-list-style';
    s.textContent = `

        .boost-sd__product-list {
      display: flex !important;
      flex-direction: column !important;
      gap: 0 !important;
      margin: 0 !important;
    }
    .boost-sd__product-list .boost-sd__product-item {
      display: flex !important;
      flex-direction: row !important;
      align-items: flex-start !important;
      width: 100% !important;
      padding: 16px 0 !important;
      border-bottom: 1px solid #e5e5e5 !important;
    }
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout-image {
      flex: 0 0 200px !important;
      width: 200px !important;
      min-width: 200px !important;
      margin-right: 20px !important;
    }
    .boost-sd__product-list .boost-sd__product-image-wrapper {
      width: 200px !important;
      height: 112px !important;
      border-radius: 6px !important;
      overflow: hidden !important;
    }
    .boost-sd__product-list .boost-sd__product-image-img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
    }
    .boost-sd__product-list .boost-sd__product-info-wrapper {
      flex: 1 1 auto !important;
      width: auto !important;
      padding-right: 16px !important;
    }
    .boost-sd__product-list .boost-sd__product-info {
      flex-direction: column !important;
    }
    .boost-sd__product-list .boost-sd__product-title {
      font-size: 16px !important;
      font-weight: 700 !important;
      color: #25303e !important;
      margin-bottom: 2px !important;
      display: block !important;
    }
    .boost-sd__product-list .boost-sd__product-vendor {
      font-size: 13px !important;
      color: #6e6e6e !important;
      margin-bottom: 6px !important;
      display: block !important;
    }
    .boost-sd__product-list .boost-sd__product-description {
      font-size: 13px !important;
      color: #555 !important;
      line-height: 1.5 !important;
      display: block !important;
      overflow: visible !important;
      max-height: none !important;
      -webkit-line-clamp: unset !important;
      margin-bottom: 8px !important;
    }
    .boost-sd__product-list .boost-sd__product-price {
      font-size: 15px !important;
      font-weight: 700 !important;
      color: #25303e !important;
      margin-top: 4px !important;
    }
  @media (min-width: 768px) {
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout {
      align-items: center !important;
    }
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout-image {
      flex: 0 0 280px !important;
      width: 280px !important;
      min-width: 280px !important;
    }
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-image-wrapper {
      width: 280px !important;
      height: 157px !important;
    }
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-info-wrapper {
      padding-right: 170px !important;
    }
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-info > .boost-sd__product-link::after {
      content: "View Details";
      position: absolute;
      top: 14px;
      right: 0;
      background-color: #8cc63f;
      border: 1px solid #7aad37;
      color: #fafafa;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      padding: 6px 16px;
      border-radius: 17px;
      text-align: center;
    }
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-info > .boost-sd__product-link:hover::after {
      background-color: #7aad37;
    }
    .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-price {
      position: absolute !important;
      top: 70px !important;
      right: 0 !important;
      text-align: right !important;
      font-size: 17px !important;
    }
  }
    .boost-sd__product-price-wrapper {
      margin-top: 6px;
      top: -20px;
      position: relative;
    }
    @media (max-width: 767px) {
      .boost-sd__product-list .boost-sd__product-item {
        flex-direction: column !important;
        align-items: stretch !important;
        padding: 12px 0 !important;
      }
      .boost-sd__product-list .boost-sd__product-item-grid-view-layout-image {
        flex: 0 0 auto !important;
        width: 100% !important;
        min-width: unset !important;
        margin-right: 0 !important;
        margin-bottom: 10px !important;
      }
      .boost-sd__product-list .boost-sd__product-image-wrapper {
        width: 100% !important;
        height: auto !important;
        aspect-ratio: 16 / 9 !important;
      }
      .boost-sd__product-list .boost-sd__product-info-wrapper {
        width: 100% !important;
        padding-right: 0 !important;
      }
      .boost-sd__product-list .boost-sd__product-title {
        font-size: 15px !important;
      }
      .boost-sd__product-list .boost-sd__product-vendor {
        font-size: 12px !important;
      }
      .boost-sd__product-list .boost-sd__product-description {
        font-size: 12px !important;
        margin-bottom: 6px !important;
      }
      .boost-sd__product-list .boost-sd__product-price {
        font-size: 14px !important;
      }
      .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-info-wrapper {
        position: relative !important;
      }
      .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-title {
        padding-right: 130px !important;
      }
      .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-vendor {
        padding-right: 130px !important;
        margin-bottom: 28px !important;
      }
      .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-info > .boost-sd__product-link::after {
        content: "View Details";
        position: absolute;
        top: 0;
        right: 0;
        background-color: #8cc63f;
        border: 1px solid #7aad37;
        color: #fafafa;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        padding: 6px 16px;
        border-radius: 17px;
        text-align: center;
      }
      .boost-sd__product-list .boost-sd__product-item-grid-view-layout .boost-sd__product-price {
        position: absolute !important;
        top: 42px !important;
        right: 0 !important;
        text-align: right !important;
        font-size: 16px !important;
        margin: 0 !important;
      }
      .boost-sd__product-price-wrapper {
        top: 0px!important;
      }
    }
    .boost-sd__product-info-wrapper {
      align-self: flex-start !important;
    }

  `;
    document.head.appendChild(s);
  }

  ensureStyle();

  window.addEventListener('popstate', ensureStyle);
  window.addEventListener('hashchange', ensureStyle);

  window.addEventListener('pageshow', ensureStyle);
  document.addEventListener('visibilitychange', ensureStyle);

  ['pushState', 'replaceState'].forEach(function (method) {
    var orig = history[method];
    history[method] = function () {
      var result = orig.apply(this, arguments);
      setTimeout(ensureStyle, 0);
      return result;
    };
  });

  new MutationObserver(ensureStyle).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // --- Read More / Read Less toggle
  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('.boost-sd__read-more-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var desc = btn.closest('.boost-sd__product-description');
    if (!desc) return;

    var isExpanded = desc.classList.contains('is-expanded');
    var textNode = desc.childNodes[0];

    if (isExpanded) {
      textNode.textContent = desc.dataset.short;
      btn.textContent = 'Read More';
      desc.classList.remove('is-expanded');
    } else {
      textNode.textContent = desc.dataset.full;
      btn.textContent = 'Read Less';
      desc.classList.add('is-expanded');
    }
  });

})();